import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { Wiggle } from 'SRC'

const Calendar = styled(({className}) => {
  return (
    <svg className={className} version='1.1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 600 600'>
      <path d='M484.45,179.68c-1.62-7.23-7.02-20.14-26.4-24.86l-33.39,1.3c0,0,4.07-56.52-57.01-55.64
        c-57.67,3.52-48.51,59.02-49.37,59.82c-0.86,0.79-58.11,7.51-59.13,6.58c-1.02-0.94-7.66-58.48-57.01-58.48
        c-54.08,6.84-41.54,67.28-41.54,67.28s-37.9,4.13-43.35,20.01c-7.04,78.16-23.61,268.69-20.99,271.08c2.62,2.4,47.29-5.05,49.74-3.2
        c2.44,1.85-0.05,19.98,2.45,21.72c159.22-12.1,343.64-29.92,343.64-29.92S493.4,223.07,484.45,179.68z M326.76,135.14
        c4.34-14.5,24.92-25.36,31.22-26.06c6.3-0.71,23.51-0.98,25.85,0.22c25.19,10.26,24.71,16.45,28.78,29.83
        c2.47,8.12,0.86,27.31-0.49,35.08c-1.14,6.14-16.7,38.44-30.22,44.88c-7.82,2.44-23.89,4.34-29.48-0.33
        c-1.47-1.25-2.13-6.33,0.18-6.7c5.44-0.88,9.04,1.27,10.57,1.81c4.56,1.63,12.95,0.98,16.29-0.98c3.3-1.93,12.24-10.43,17.67-26.06
        c4.34-18.62,2.77-33.28,0.6-40.07c-2.17-6.79-4.05-15.77-13.18-23.09c-7.82-6.27-13.93-8.23-24.19-7.29
        c-20.89,4.4-25.78,17.13-26.21,21.48c-1.25,4.56,0.05,17.97-1.74,19.98c-1.79,2.01-5.32,2.06-6.62-0.16
        C324.48,155.45,324.53,141.87,326.76,135.14z M343.78,204.34c4.32-6.35,24.52-14.66,36.24-8.55c9.45,4.92-6.28,11.68-9.28,11.89
        c-10.21,0.73-16.62-2.42-19.88-1.19c-6.52,2.44-6.22,13.13-3.09,17.81c2.28,3.42,12.65,1.92,19.67,2.52
        c14.21,1.22,19.83-7.25,25.62-5.38c3.91,4.89-5.95,20.69-21.99,21.75c-13.85,0.98-23.29-6.19-29.24-16.05
        C337.87,220.59,339.46,210.69,343.78,204.34z M359,122.3c25.58-4.21,31.77,25.92,30.31,27.39c-1.47,1.47-44.31,7.66-45.94,6.52
        S332.46,132.42,359,122.3z M202.6,115.99c31.95,0,46.04,34.47,46.53,43.47c0.65,11.97-0.65,32.33-8.63,46.18
        c-9.52,16.51-17.53,22.51-23.45,23.08s-18.09,1.76-22.35-2.75c-1.36-1.44-1.09-6.59,1.66-6.73c3.61-0.19,14.64,4.87,17.96,2.96
        c8.23-4.72,28.14-31.77,20.89-63.32c0,0-4.83-28.32-30.52-28.91c-7.68,0.16-33.67-1.79-28.24,43.87c0.25,2.11-7.22,3.01-7.96,0
        C155.96,138.21,185.77,117.68,202.6,115.99z M188.62,210.67c4.02-3.04,15.47-5.57,19.22-5c5.13,0.79,6.16,8.27,2.44,9.42
        c-2.89,0.9-13.68-1.63-18.19,1c-2.26,1.32-3.72,6.98-2.55,11.11c0.9,3.16,8.75,6.81,12.97,6.81c2.11,0,9.19,0.84,14.44-0.43
        c7.17-1.74,9.33-5.47,10.58-5.31c2.5,0.33,3.54,0.42,3.54,2.81c0,2.39-6.62,22.48-24.43,22.48c-16.18,0-24.43-9.77-24.43-18.57
        C181.27,224.24,184.6,213.71,188.62,210.67z M199.37,136.98c28.68-5.86,29.32,27.37,27.38,29c-1.95,1.63-41.06,5.38-42.85,3.91
        S174.94,146.59,199.37,136.98z M143.66,451.86c-2.32,0.98-30.22,6.43-37.14,5.86c-3.01-8.76,10.21-206.77,13.68-212.42
        C129.82,250.41,148.96,447.5,143.66,451.86z M483.79,446c-6.25,2.04-285.28,32.52-328.78,31.44
        c-2.56-52.66-13.52-162.62-19.17-195.64c-0.3-1.75,342.72-34.17,344.04-33.23C481.2,249.5,485.89,444.88,483.79,446z'/>
      <path d='M258.99,365.85c-5.21,0.33-25.41,13.36-25.41,16.29c0,2.93,53.21,60.6,62.55,60.6
        c9.34,0,123.15-132.71,123.15-135.53s-15.31-20.85-20.2-20.85c-4.89,0-98.5,115.22-102.3,115.33
        C292.98,401.8,264.21,365.53,258.99,365.85z'/>
    </svg>
  )
})`
  &:hover {
    ${props => props.animated && Wiggle}
  }
  path {
    fill: ${props => props.theme.colors.rocketBlue};
  }
`

Calendar.propTypes = {
  animated: PropTypes.bool,
  theme: PropTypes.shape({
    colors: PropTypes.shape({
      rocketBlue: PropTypes.string
    })
  })
}

/** @component */
export default Calendar



// WEBPACK FOOTER //
// ./src/core/icons/Calendar.js